import { setupWorker } from 'msw';
import { handlers } from './handlers';
import { environment } from '../environments/environment';

const worker = setupWorker(...handlers);

export const initServer = () => {
  if (typeof window !== 'undefined') {
    const basePath = environment.publicUrl.split('/').filter((v) => v).join('/');
    return worker.start({
      serviceWorker: {
        url: `/${basePath !== '' ? `${basePath}/` : ''}mockServiceWorker.js`,
      },
    });
  }

  return Promise.resolve();
};
